import { BaseEntityLineChart } from '../../../components/Charts';
import { useMajorsChart } from '../hooks/useMajorsChart';
import { useAppSelector } from '../../../store/hooks';

interface MajorsChartProps {
	height?: number;
}

export function MajorsChart({ height = 400 }: MajorsChartProps) {
	const selectedFaculty = useAppSelector((state) => state.filters.selectedFaculty);

	const { nivoData, isLoading, error } = useMajorsChart({
		filters: {
			maKhoa: selectedFaculty ? [selectedFaculty] : undefined
		}
	});

	return (
		<BaseEntityLineChart
			height={height}
			title="Biểu đồ Sinh viên theo Ngành"
			downloadFilename="bieu-do-nganh"
			entityLabel="Chọn ngành"
			entityPlaceholder="Tất cả ngành"
			groupByEntity
			nivoData={nivoData}
			isLoading={isLoading}
			error={error}
		/>
	);
}
